import { render, staticRenderFns } from "./labelManageGroupDetail.vue?vue&type=template&id=58a23ac2&scoped=true&"
import script from "./labelManageGroupDetail.vue?vue&type=script&lang=js&"
export * from "./labelManageGroupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a23ac2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a23ac2')) {
      api.createRecord('58a23ac2', component.options)
    } else {
      api.reload('58a23ac2', component.options)
    }
    module.hot.accept("./labelManageGroupDetail.vue?vue&type=template&id=58a23ac2&scoped=true&", function () {
      api.rerender('58a23ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/labelManage/labelManageGroupDetail.vue"
export default component.exports